<template>
  <v-layout
    row
    wrap
  >
    <span class="filter-field ma-2 body-2">{{ filter.label }}</span>
    <v-select
      v-model="filter.operator"
      :items="operators"
      class="ma-2"
      dense
      solo
    />
    <v-text-field
      v-model="filter.value"
      class="ma-2"
      dense
      solo
    />
    <v-icon
      @click="$emit('delete')"
    >
      cancel
    </v-icon>
  </v-layout>
</template>

<script>
export default {
  name: 'NumberFilter',

  props: {
    filter: {
      type: Object,
      required: true,
      default: () => {}
    }
  },

  data () {
    return {
      operators: ['gt', 'gte', 'eq', 'lte', 'lt']
    }
  }
}
</script>

<style lang="stylus" scoped>
  .v-select {
    max-width: 100px
  }
  .v-icon {
    margin-top: -20px
  }
  .filter-field {
    margin-top: 20px !important
    min-width: 60px
  }
</style>
